// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum enumName_mi_shared {
  Country = "Country",
  IdDocumentType = "IdDocumentType",
  PersonType = "PersonType",
}
